/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const svRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Ansök för att lägga till skola',
    description: 'Vad god fyll i formuläret nedan. Anmälda skolor är inte garanterade att läggas till, men alla ansökningar undersöks och granskas av SheerID. ',
    noCountry: 'Ser du inte ditt lands skola? Då är du inte valbar för detta erbjudande',
    searchByOrgName: 'Ser du inte din skola? Sök på namn',
    completeRequest: 'Ser du inte din skola i listan för valbara och inte valbara skolor? Slutför din ansökan',
    submit: 'Lämna in',
    eligibleOrgs: 'Valbara skolor. Klicka på ikonen för att kopiera namnet och återvänd sedan till verifieringsformuläret',
    ineligibleOrgs: 'Inte valbara skolor. Vi beklagar, studenter på dessa skolor är inte valbara för det här erbjudandet',
    none: 'Ingen',
    country: 'Var går du i skolan?',
    changeLanguage: 'Ändra språk',
    copied: 'Kopierad',
    firstName: 'Namn',
    lastName: 'Efternamn',
    emailAddress: 'E-postadress',
    poweredBy: 'Verifieringstjänster drivna av SheerID',
    fields: {
        countryPlaceholder: 'Välj land',
        domainLabel: 'Skolans hemsida',
        domainPlaceholder: 'www.min_högskola.se',
        orgNameLabel: 'Skolans namn',
        orgNamePlaceholder: 'Min skola',
    },
    step: {
        success: {
            title: 'Tack för att du har lämnat in din ansökan',
            description: 'Som påminnelse utvärderas varje förfrågan av SheerID mot kraven som ställs i det här erbjudandet. Det finns ingen garanti för att er skola kommer att läggas till. Utvärderingsprocessen kommer att ta upp till 7 dagar.',
        },
        error: {
            title: 'Ett oväntat fel uppstod',
            description: 'Vi beklagar att vi inte kan behandla din ansökan. Var god och försök igen senare.',
            seeingProblem: 'Om detta problem återkommer',
            contactUs: 'kontakta oss',
        },
    },
    errorId: {
        invalidCountry: 'Fältet är obligatoriskt',
        invalidEmail: 'Ogiltig mailadress',
        invalidFirstName: 'Ogiltigt namn',
        invalidLastName: 'Ogiltigt efternamn',
        requiredField: 'Fältet är obligatoriskt',
        invalidField: 'Fältet är ogiltigt',
        invalidUrl: 'Ogiltig URL',
        tooManyResults: 'Din sökning gav för många resultat, var god och förfina din sökning och försök igen',
    },
    faq: 'SheerID Lägg till skol-förfrågan FAQ',
    countries: {
        AD: 'Andorra',
        AE: 'Förenade Arabemiraten',
        AF: 'Afghanistan',
        AG: 'Antigua och Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AN: 'Nederländska Antillerna',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Amerikanska Samoa',
        AT: 'Österrike',
        AU: 'Australien',
        AW: 'Aruba',
        AZ: 'Azerbajdzjan',
        BA: 'Bosnien och Hercegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam ',
        BO: 'Bolivia',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvetön',
        BW: 'Botswana',
        BY: 'Vitryssland',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Kongo-Kinshasa',
        CF: 'Centralafrikanska republiken',
        CG: 'Kongo',
        CH: 'Schweiz',
        CI: 'Elfenbenskusten (Côte d\'Ivoire)',
        CK: 'Cooköarna',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Kina',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Kap Verde',
        CY: 'Cypern',
        CZ: 'Tjeckien',
        DE: 'Tyskland',
        DJ: 'Djibouti',
        DK: 'Danmark',
        DM: 'Dominica',
        DO: 'Dominikanska republiken',
        DZ: 'Algeriet',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Egypten',
        EH: 'Västsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: 'Etiopien',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falklandsöarna',
        FM: 'Mikronesien',
        FO: 'Färöarna',
        FR: 'Frankrike',
        GA: 'Gabon',
        GB: 'Storbritannien',
        GD: 'Grenada',
        GE: 'Georgien',
        GF: 'Franska Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grönland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (Franska)',
        GQ: 'Ekvatorialguinea',
        GR: 'Grekland',
        GS: 'Sydgeorgien och Sydsandwichöarna',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard- och McDonaldöarna',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungern',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IN: 'Indien',
        IO: 'Brittiska territoriet i Indiska oceanen',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Island',
        IT: 'Italien',
        JM: 'Jamaica',
        JO: 'Jordanien',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kirgizistan',
        KH: 'Kambodja',
        KI: 'Kiribati',
        KM: 'Komorerna',
        KN: 'Saint Kitts och Nevis Anguilla',
        KP: 'Nordkorea',
        KR: 'Sydkorea',
        KW: 'Kuwait',
        KY: 'Caymanöarna',
        KZ: 'Kazakstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        LY: 'Libyen',
        MA: 'Marocko',
        MC: 'Monaco',
        MD: 'Moldavien',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshallöarna',
        MK: 'Makedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongoliet',
        MO: 'Macao',
        MP: 'Nordmarianerna',
        MQ: 'Martinique (Franska)',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldiverna',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malaysia',
        MZ: 'Moçambique',
        NA: 'Namibia',
        NC: 'Nya Kaledonien (Franska)',
        NE: 'Niger',
        NF: 'Norfolkön',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Nederländerna',
        NO: 'Norge',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nya Zeeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesien (Franska)',
        PG: 'Papua Nya Guinea',
        PH: 'Filippinerna',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint-Pierre och Miquelon',
        PN: 'Pitcairnöarna',
        PR: 'Puerto Rico',
        PS: 'Palestina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Réunion (Franska)',
        RO: 'Rumänien',
        RS: 'Serbien',
        RU: 'Ryska federationen',
        RW: 'Rwanda',
        SA: 'Saudiarabien',
        SB: 'Salomonöarna',
        SC: 'Seychellerna',
        SD: 'Sudan',
        SE: 'Sverige',
        SG: 'Singapore',
        SH: 'Sankta Helena',
        SI: 'Slovenien',
        SK: 'Slovakien',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Södra Sudan',
        ST: 'São Tomé och Príncipe',
        SV: 'El Salvador',
        SY: 'Syrien',
        SZ: 'Swaziland',
        TC: 'Turks- och Caicosöarna',
        TD: 'Tchad',
        TF: 'Franska sydterritorierna',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tadzjikistan',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistan',
        TN: 'Tunisien',
        TO: 'Tonga',
        TR: 'Turkiet',
        TT: 'Trinidad och Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: 'Förenta staternas mindre öar i Oceanien och Västindien',
        US: 'Förenta staterna',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatikanstaten',
        VC: 'Saint Vincent och Grenadinerna',
        VE: 'Venezuela',
        VG: 'Jungfruöarna (Brittiska)',
        VI: 'Jungfruöarna (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis- och Futunaöarna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Sydafrika',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: ' Arabiska',
        bg: 'Bulgariska',
        cs: 'Tjeckiska',
        da: 'Danska',
        de: 'Tyska',
        el: 'Grekiska',
        'en-GB': 'Engelska (Storbritannien)',
        'en-US': 'Engelska',
        'es-ES': 'Spanska (Spanien)',
        es: 'Spanska',
        fi: 'Finska',
        'fr-CA': 'Franska (Kanada)',
        fr: 'Franska',
        hr: 'Kroatiska',
        hu: 'Ungerska',
        id: 'Indonesiska',
        is: 'Isländska',
        it: 'Italienska',
        iw: 'Hebreiska',
        ja: 'Japanska',
        ko: 'Koreanska',
        lt: 'Litauiska',
        ms: 'Malajiska',
        nl: 'Nederländska',
        no: 'Norska',
        pl: 'Polska',
        'pt-BR': 'Portugisiska (Brasilien)',
        pt: 'Portugisiska',
        ro: 'Rumänska',
        ru: 'Ryska',
        sk: 'Slovakiska',
        sl: 'Slovenska',
        sr: 'Serbiska',
        sv: 'Svenska',
        tr: 'Tukiska',
        'zh-HK': 'Kinesiska (Hong Kong)',
        zh: 'Kinesiska (Traditionell)',
    },
};
